// extracted by mini-css-extract-plugin
module.exports = {"block":"EmptyBlock_block__6WsR4","title":"EmptyBlock_title__wSuhr"};